import { render } from "./GamePane.vue?vue&type=template&id=3f15f428&scoped=true"
import script from "./GamePane.vue?vue&type=script&lang=js"
export * from "./GamePane.vue?vue&type=script&lang=js"

import "./GamePane.vue?vue&type=style&index=0&id=3f15f428&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f15f428"]])

export default __exports__